module.exports = __webpack_public_path__ + "static/mission-a59c1d6ba5b6d2244e5aeb3b46f3c318.png";